import React, { ReactNode } from 'react';
import cx from 'classnames';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { Collapse as CollapseArco } from '@m4b-design/components';
import { RoleType } from '@/constants';
import { TAB_TOP_ID } from '@/pages/Homepage/constants';
import { AnchorTo } from '@/pages/Homepage/components';
import sellerIcon from './imgs/SellerIcon.png';
import { useCollapse, UseCollapseOptions } from './index.ViewHook';
import styles from './index.scss';
import { ContentsType } from '@/api/seller/serv/oec_seller_learning_center_api';
import { useUpdateEffect } from '@byted/hooks';
import { Tea } from '@features/libs/tea';

interface CollapseProps extends UseCollapseOptions {
  className?: string;
  sellerNode?: ReactNode;
  creatorNode?: ReactNode;
  tab: ContentsType;
}

export const Collapse = ({
  className,
  sellerNode,
  defaultActiveKey,
  tab,
  onChange,
}: CollapseProps) => {
  const { t } = useTranslation();
  const { active, handleChange } = useCollapse({
    defaultActiveKey,
    onChange,
  });
  useUpdateEffect(() => {
    Tea('button_click', {
      page_name: 'seller_university_homepage',
      module_name: 'menu_role_change',
      tab_name:
        Object.keys(ContentsType)[Object.values(ContentsType).indexOf(tab)],
      click_for: Object.keys(RoleType)[Object.values(RoleType).indexOf(active)],
    });
  }, [active, tab]);
  const options = [
    {
      name: RoleType.Seller.toString(),
      title: t('academy_content_role_seller'),
      icon: <img src={sellerIcon} alt={'seller type icon'} />,
      content: sellerNode,
    },
  ];

  return (
    <CollapseArco
      className={cx(styles.Collapse, className)}
      activeKey={active.toString()}
      accordion
      bordered={false}
      expandIcon={null}
      onChange={handleChange}>
      {options.map(({ name, title, content }) => {
        return (
          <CollapseArco.Item
            key={name}
            name={name}
            header={{
              title: (
                <>
                  <AnchorTo anchor={TAB_TOP_ID} />
                  {title}
                </>
              ),
            }}>
            {content}
          </CollapseArco.Item>
        );
      })}
    </CollapseArco>
  );
};
